// extracted by mini-css-extract-plugin
export default {"ProductContent":"styles_ProductContent__YJzdn"};